import React from 'react'
import Container from '../amex/contenedor'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Titular = styled.h3`
  color: ${props => props.theme.colors.amexGrisTexto};
`

const TituloColumna = styled.h4`
  margin-top: 0;
  color: ${props => props.theme.colors.amexGrisTexto};
`

const Grid = styled.div`
  ${breakpoint('tablet')`
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
  `}
`

const Columna = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 13px;

  ${breakpoint('tablet')`
    flex: 0 0;
    flex-basis: calc(33.3333% - 20px);
    margin: 0 10px;
    font-size: 16px;
  `}

  a {
    color: ${props => props.theme.colors.amexBlue};
    text-decoration: none;
  }
`

const IconContainer = styled.div`
  margin-right: 20px;
  flex: 0 0;
  flex-basis: 30px;

  ${breakpoint('tablet')`
    flex-basis: 90px;
  `}

  img {
    width: 100%;
  }
`

const Disclaimer = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.amexGrisTexto};
`

const formatLink = (link, text) => {
  var result = null

  if (link == null) {
    result = null
  } else {
    if (link.includes('@')) {
      result = <a href={`mailto:${link}`}>{link}</a>
    } else if (link.includes('http')) {
      result = <a href={link}>{text || link}</a>
    } else {
      result = <a href={`tel:+506${link}`}>{link}</a>
    }
  }

  return result
}

const Contacto = ({ contacto, disclaimer, noTitle }) => {
  return (
    <Container>
      <div>
        {!noTitle && <Titular>Información de contacto</Titular>}
        <Grid>
          {contacto.map((columna, i) => (
            <Columna key={i}>
              <IconContainer>
                <img src={columna.icono} alt={columna.titulo} />
              </IconContainer>
              <div>
                <TituloColumna>{columna.titulo}</TituloColumna>
                <p>
                  {columna.texto} {formatLink(columna.link, columna.linkText)}{' '}
                </p>
              </div>
            </Columna>
          ))}
        </Grid>
      </div>
      <Disclaimer>
        <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
      </Disclaimer>
    </Container>
  )
}

export default Contacto
